import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubCategories } from "../../Redux/Slices/Categories/subCategoriesAction";
import Products from "../Products/Products";
import { getProducts } from "../../Redux/Slices/Products/productsAction";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";

const Ferreteria = () => {
    const dispatch = useDispatch();
    const { products } = useSelector((state) => state.products);
    const [selectedSubCategory, setSelectedSubCategory] = useState("Todos");
    const [selectedProducts, setSelectedProducts] = useState([]);
    
    useEffect(() => {
      dispatch(getProducts());
    }, [dispatch]);
  
    
    useEffect(() => {
      if (Array.isArray(products)) {
        if (selectedSubCategory === "Todos") {
          setSelectedProducts(products);
        } else {
          setSelectedProducts(
            products.filter(
              (product) => product.subCategory && product.subCategory === selectedSubCategory
            )
          );
        }
      }
    }, [selectedSubCategory, products]);
    
    const handleFilterSubCategories = (event) => {
      setSelectedSubCategory(event.target.value);
    };
    return (
        <div class=" overflow bg-gray-300">
            <NavBar />
            <div
                class="mt-10 pt-2 mt-1 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
                style={{ marginTop: "40px" }}
            >
                <select
                    class=" mt-10 pt-2 rounded-lg border-2 border-red-300 mt-1 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
                    onChange={handleFilterSubCategories}
                    value={selectedSubCategory}
                >
                    <option value="Todos">Todos</option>
                    <option value="Mallas">Mallas</option>
                    <option value="Cuerdas">Cuerdas</option>
                    <option value="Jardineria y Riego">
                        Jardineria y Riego
                    </option>
                    <option value="Cementos">Cementos</option>
                    <option value="Estuco">Estuco</option>
                    <option value="Yeso">Yeso</option>
                    <option value="Arenas y Gravas">Arenas y Gravas</option>
                    <option value="Electricidad">Electricidad</option>
                    <option value="Cerraduras y Herrajes">
                        Cerraduras y Herrajes
                    </option>
                    <option value="Accesorios PVC">Accesorios PVC</option>
                    <option value="Tornilleria">Tornilleria</option>
                    <option value="Herramientas Manuales">
                        Herramientas manuales
                    </option>
                    <option value="Medicion">Medicion</option>
                    <option value="Cintas">Cintas</option>
                    <option value="Pisos y Paredes">Pisos y Paredes</option>
                    <option value="Pegantes">Pegantes</option>
                    <option value="Lubricantes">Lubricantes</option>
                    <option value="Baño y Cocina">Baño y Cocina</option>
                    <option value="Aseo">Aseo</option>
                    <option value="Alambres">Alambres</option>
                    <option value="Drywall">Drywall</option>
                    <option value="Accesorios para construccion">
                        Accesorios para construccion
                    </option>
                    <option value="Tuberias PVC">Tuberias PVC</option>
                </select>
            </div>

            <div class=" mt-10 flex justify-center flex-wrap bg-gray-300 ">
                {selectedProducts?.map((el) => {
                    return (
                        <div class="bg-gray-300">
                            <Products
                                key={el.id}
                                id={el.id}
                                name={el.name}
                                image={el.image}
                                description={el.description}
                                disponible={el.disponible}
                                price={el.price}
                            />
                        </div>
                    );
                })}
            </div>
            <div class="bottom-0 w-full bg-gray-300">
                <Footer />
            </div>
        </div>
    );
};

export default Ferreteria;